import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import commonDatas  from '../../apps/CommonDatas'
import './Camera.css';

var isVideoLoaded = false;
var webCamWidth = 100;
var webCamHeight = 100;

export function Camera () {
  const location = useLocation();
  const navigate = useNavigate()
  const { model } = location.state;
    
  let baseIsError = false;
  const maskObj = commonDatas.getMaskData(model);
  if( maskObj === null ){
    baseIsError = true;
  }
  const startMatchFlag = useRef(false);
  const [isStart, setIsStart] = useState(true);
  const [isError, setIsError] = useState(baseIsError);
  const [isLoading, setIsLoading] = useState(true);
  const [isApiError, setIsApiError] = useState(false);
  
  const onStartPopupCloseClick = function(e){
    e.preventDefault();

    setIsStart(false);
    startMatchFlag.current = true;
  }
  const onResizeCameraProc = function(){

    var contentInner = document.getElementById("content_inner");
    var videoArea   = document.getElementById("video_area");
    var videoObj    = document.getElementById("video_obj");

	videoObj.style.height = "auto";
	videoObj.style.width = "auto";

    var w = document.body.clientWidth;
    var scale = w / 640.0;

    var videoWidth = w;
    videoArea.style.width = w + "px";
    videoArea.style.height = w + "px";
    videoArea.style.top = (35 * scale) + "px";
    if( isVideoLoaded ){
        var margin = ((2 * videoWidth) - w) / 2;


        if( videoObj.clientWidth > videoObj.clientHeight ){
            videoObj.style.height = (2 * videoWidth) + "px";
            videoObj.style.width  = (2 * videoWidth * videoObj.clientWidth / videoObj.clientHeight) + "px";

            videoObj.style.top = -margin + "px";
            videoObj.style.left =  "-" + (margin + (videoObj.clientWidth - videoObj.clientHeight) / 2) + "px";
        }else{
            videoObj.style.width = (2 * videoWidth) + "px";
            videoObj.style.height = (2 * videoWidth * videoObj.clientHeight / videoObj.clientWidth) + "px";

            videoObj.style.left = -margin + "px";
            videoObj.style.top = "-" + (margin + (videoObj.clientHeight - videoObj.clientWidth) / 2) + "px";
        }
    }
    contentInner.style.width =  w + "px";
  }
  
  useEffect(() => {
    document.getElementsByTagName("html")[0].scrollTop = 0;
	document.body.scrollTop = 0;
	
	const handleWindowResize = function(){
      onResizeCameraProc();
    }
  
    var videoElem   = document.getElementById("video_obj");
	if( maskObj !== null ){
		var depth = 4;
		var sizeWidth = 240, sizeHeight = 320;
		var filterSize = 240;
		var filterLeft = 0, filterTop = 0;
		var videoWidth, videoHeight;
		var ua = navigator.userAgent;
		if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 ) {
		  if( window.orientation % 180 !== 0 ){
		    videoWidth = sizeHeight;
		    videoHeight = sizeWidth;
		    filterLeft = 40;
		  }else{
		    videoWidth = sizeWidth;
		    videoHeight = sizeHeight;
		    filterTop = 40;
		  }
		} else {
		  videoWidth = sizeHeight;
		  videoHeight = sizeWidth;
		  filterLeft = 40;
		}
		var pixels;
		var drawFlag = false;
		
	
		var dispElem    = document.createElement("canvas");
	 	dispElem.width  = videoWidth;
		dispElem.height = videoHeight;

		var dispCtx   = dispElem.getContext('2d');
		
		var objMatchRate = 0.8;
		
		var filterList = [];
	    var workList   = [];
	    var pointList  = [];
	    var filterImgList = [];
	    var matchRate  = 0;
	    var disMatchRate = 0;
	    
        pointList = maskObj.point;

        if( maskObj.filter.length > 0 ){
            for( var i = 0;i < maskObj.filter.length;i++ ){
                var filterElem    = document.createElement("canvas");

                filterElem.width  = filterSize;
                filterElem.height = filterSize;

                var canvalId = "#filter" + i + "_img";

                var filterImg = new Image();
                filterImg.canvasId = canvalId;
                filterImg.src = maskObj.filter[i];
                filterImgList.push( filterImg );

                filterList.push( filterElem );
                workList.push(new Array(filterSize * filterSize));
            }
        }

        matchRate = maskObj.match;
        disMatchRate = maskObj.dis_match;

		const modelFrameObj = document.getElementById("model_frame");
		const fixedFrameObj = document.getElementById("fixed_frame");
		modelFrameObj.src = './images/model' + model + '_matching.png';
		fixedFrameObj.src = './images/model' + model + '_fixed.jpg';

	    onResizeCameraProc();
		window.addEventListener('resize', handleWindowResize);
		
		const dp = function(x, y){
        	return ( y * depth ) * filterSize + x * depth;
    	}
    	const checkColor = function( br, bg, bb, x, y ){
	        var p = dp(x, y);
	        var r = pixels.data[p];
	        var g = pixels.data[p + 1];
	        var b = pixels.data[p + 2];
	
	        var dr = Math.abs(br - r);
	        var dg = Math.abs(bg - g);
	        var db = Math.abs(bb - b);
	
	        if((dr < 40) && (dg < 30) && (db < 30) ){
	            return true;
	        }
	        return false;
        }
		const myDraw = function(){
	        if( !drawFlag ){
	            drawFlag = true;
	
	            dispCtx.drawImage(videoElem, webCamWidth / 4, webCamHeight / 4, webCamWidth / 2, webCamHeight / 2, 0, 0, dispElem.width, dispElem.height);
				if( startMatchFlag.current ){
		            pixels = dispCtx.getImageData(filterLeft, filterTop, filterSize, filterSize);
		            
		            var i, j, x, y;
		            var matchCount = 0;
		
		            for( i = 0;i < workList.length;i++ ){
		                var workObj = workList[i];
		                for( j = 0;j < workList[i].length;j++ ){
		                    workObj[j] = 0;
		                }
		
		                var cx, cy;
		                if( i < pointList.length ){
		                    cx = pointList[i].x;
		                    cy = pointList[i].y;
		                }else{
		                    cx = Math.floor(filterSize / 2);
		                    cy = Math.floor(filterSize / 2);
		                }
		                j = dp(cx, cy);
		                var br = pixels.data[j];
		                var bg = pixels.data[j + 1];
		                var bb = pixels.data[j + 2];
		
		                if((br === 0) && (bg === 0) && (bb === 0)){
		                    break;
		                }
		
		                var ctx = filterList[i].getContext('2d');
		
		                ctx.drawImage(filterImgList[i], 0, 0, filterSize, filterSize, 0, 0, filterSize, filterSize);
		                var filterPixels = ctx.getImageData(0, 0, filterSize, filterSize);
		
		                var matchFlag = 0;
		                var disMatchFlag = 0;
		                var mc = 0;
		                var dc = 0;
		                for( y = 0;y < filterSize;y++ ){
		                    for( x = 0;x < filterSize;x++ ){
		                        j = dp( x, y );
		                        var key = filterPixels.data[j];
		
		                        if( key === 0 ){
		                            dc++;
		                            if( !checkColor( br, bg, bb, x, y )){
		                                disMatchFlag++;
		                            }
		                        }else if( key === 255 ){
		                            mc++;
		                            if( checkColor( br, bg, bb, x, y )){
		                                matchFlag++;
		                            }
		                        }
		                    }
		                }
		                if( ( disMatchFlag / dc >= disMatchRate ) && ( matchFlag / mc >= matchRate ) ){
		                    matchCount++;
		                }
		            }
		
		            if( matchCount / workList.length >= objMatchRate ){
		                onMatchModel();
		            }
		        }
	
	            drawFlag = false;
	            requestAnimationFrame(myDraw);
	        }
  		}
  		const onMatchModel = function(){

	        startMatchFlag.current = false;
	
	        var foundModelList = commonDatas.loadFoundList();
	
	        var param = model.split("_");
	        var gid = parseInt(param[0]) - 1;
	        var oid = parseInt(param[1]) - 1;
	        foundModelList[gid][oid] = true;
	
	        modelFrameObj.style.display = "none";
	        fixedFrameObj.style.visibility = "visible";
	        
	        const cameraObj = document.getElementById("camera");
	        cameraObj.classList.add("match");

	        if( maskObj["is_special"] ){
				cameraObj.classList.add("special");
	        }
	
            
            commonDatas.setCookie( "found_model", JSON.stringify(foundModelList) );
            commonDatas.setCookie( "last_found_model", model );
            
	        setTimeout(function(){
                commonDatas.uploadCollection(model, function(data){
                    navigate("/list");
                }, function(){
                    setIsApiError(true);
                });
	        }, 2000);
	    }
  
	    if ((navigator.mediaDevices) && (navigator.mediaDevices.getUserMedia)) {
	        var settings;
	        settings = {video: {
	            facingMode: {
	                exact: "environment"
	            }
	        }};
	        navigator.mediaDevices.getUserMedia(settings)
	            .then(
	                function(stream) {
	                    videoElem.srcObject = stream;
	                    videoElem.onloadedmetadata = function(e){
	
	                        webCamWidth = e.srcElement.videoWidth;
	                        webCamHeight = e.srcElement.videoHeight;
	
	                        isVideoLoaded = true;
	                        onResizeCameraProc();
	
	                        videoElem.play();
							setIsLoading(false);
	                    };
	                    requestAnimationFrame(myDraw);
	                })
	            .catch(function(err) {
	                settings = {video: true};
	                navigator.mediaDevices.getUserMedia(settings)
	                .then(
	                    function(stream) {
	                        videoElem.srcObject = stream;
	                        videoElem.onloadedmetadata = function(e){
	                            webCamWidth = e.srcElement.videoWidth;
	                            webCamHeight = e.srcElement.videoHeight;
	
	                            isVideoLoaded = true;
	                            onResizeCameraProc();
	                            
	                            videoElem.play();
								setIsLoading(false);
	                        };
	                        requestAnimationFrame(myDraw);
	                    })
	                .catch(function(err) {
						setIsError(true);
						setIsLoading(false);
	                });
	            });
	    }else{
	  		setIsError(true);
			setIsLoading(false);
	    }
    }
    return () => {
		window.removeEventListener('resize', handleWindowResize);		
		if( videoElem.srcObject != null ){
			const tracks = videoElem.srcObject.getTracks();
			tracks.forEach(track => {
			  track.stop();
			});
		}
		videoElem.srcObject = null;
	}
  }, [maskObj, model, navigate])
  return (
	<>
      <div id="camera" className="content_wrapper">
        <div id="video_area">
          <video id="video_obj" autoPlay playsInline></video>
        </div>
        <div className="image_area">
          <img id="model_frame" width="100%" alt="" />
          <img id="fixed_frame" width="100%" alt="" />
        </div>
        <div id="content_inner" className="content_inner">
          <div className="pt640 mb45">
            <div className="matching_label mb50"><img src="./images/match_arrow.png" width="15.3125%" alt="" /></div>
            <div className="matching_label attention_inner_header mb70">カメラをここにあわせてね</div>
            <div className="matched_label pt50 mb70"><img src="./images/match_complete_text.png" width="52.8125%" alt="ぴったりはまったね！" /></div>
            <div className="attention_inner ml85 mr85 mt45 mb55 left">
              <ul>
                <li className="infomation mb20">室内外の環境光によって認識しづらい場合がございます</li>
                <li className="infomation mb20">割れている・欠けている菓子は形を読み取れない可能性がございます</li>
                <li className="infomation mb20">菓子色と背景の色が似ていると認識しづらい場合がございます。その場合は濃い色の背景の上で読み取りください</li>
                <li className="infomation mb20">端末のカメラによっては認識しづらい場合がございます</li>
                <li className="infomation">形を読み込む際は、菓子を置いておこなってください</li>
              </ul>
            </div>
            <div><Link to="/list"><img src="./images/btn_back.png" width="74.84375%" alt="もどる" /></Link></div>
          </div>
          <div className="pb30"><img src="./images/copyright.png" width="55.46875%" alt="©Nintendo・CR・GF・TX・SP・JK ©Pokémon" /></div>

          {isStart ? <div id="start_popup" className="over_popup">
            <div className="pt175 mb85"><img src="./images/popup1_image.png" width="52.8125%" alt="" /></div>
            <div className="mb90"><img src="./images/popup1_label.png" width="74.375%" alt="おっとっとにカメラをむけてシルエットにあわせてね" /></div>
            <div className="pb50"><a className="close_popup" href="/#" onClick={(e) => onStartPopupCloseClick(e)}><img src="./images/btn_ok2.png" width="74.84375%" alt="わかった" /></a></div>
          </div> : null}
          {isError ? <div id="error_popup" className="over_popup">
            <div className="pt175 mb70"><img src="./images/popup2_image.png" width="38.125%" alt="" /></div>
            <div className="mb30"><img src="./images/popup2_label1.png" width="63.28125%" alt="もういちどやってみてね カメラの起動が確認できませんでした。" /></div>
            <div className="mb30">
              <img src="./images/popup2_label2.png" width="28.75%" alt="動作環境については" />
              <Link to="/"><img src="./images/popup2_label3.png" width="19.53125%" alt="トップページ" /></Link>
              <img src="./images/popup2_label4.png" width="26.09375%" alt="でご確認ください" />
            </div>
            <div><Link id="btn_error" to="/list"><img src="./images/btn_back.png" width="74.84375%" alt="もどる" /></Link></div>
          </div> : null}

          {isLoading ? <div id="loading" className="overlay">
            <div className="loading_wrapper">
              <div className="loading_inner">
                <div className="sk-fading-circle">
                  <div className="sk-circle1 sk-circle"></div>
                  <div className="sk-circle2 sk-circle"></div>
                  <div className="sk-circle3 sk-circle"></div>
                  <div className="sk-circle4 sk-circle"></div>
                  <div className="sk-circle5 sk-circle"></div>
                  <div className="sk-circle6 sk-circle"></div>
                  <div className="sk-circle7 sk-circle"></div>
                  <div className="sk-circle8 sk-circle"></div>
                  <div className="sk-circle9 sk-circle"></div>
                  <div className="sk-circle10 sk-circle"></div>
                  <div className="sk-circle11 sk-circle"></div>
                  <div className="sk-circle12 sk-circle"></div>
                </div>
                <div className="loading_text">Now Loading</div>
              </div>
            </div>
          </div> : null}
          {isApiError ? <div id="error" className="overlay">
            <div className="error_wrapper">
              <div className="error_inner">
                <div className="error_title">エラーが発生しました</div>
                <div className="error_text">時間をおいて再度アクセスしてください。</div>
              </div>
            </div>
          </div> : null}
        </div>
      </div>
	</>
  );
};